import { ExpandableContentWrapper } from 'components';
import { EarningsChart } from 'components/resources/EarningsChart';
import { CanvasContentId } from 'types/canvas';
import { CanvasHostShell } from './CanvasHostHeader';

interface CanvasEarningsChartProps {
  id: number;
}

const CanvasEarningsChart = ({ id }: CanvasEarningsChartProps) => (
  <ExpandableContentWrapper
    type={CanvasContentId.EARNINGS_CHART}
    styleOverrides={{
      p: 0,
      width: '100%',
      // chart is weird, 100% height makes it extend infinitely, but 98% does not
      height: '98%',
    }}
  >
    <CanvasHostShell
      componentId={id}
      contentId={CanvasContentId.EARNINGS_CHART}
    >
      <EarningsChart chartOnly={true} />
    </CanvasHostShell>
  </ExpandableContentWrapper>
);

export default CanvasEarningsChart;
